import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Age, StudyProgram } from '../clcd.service';
import { SearchService } from '../../../../../services/search/search.service';
import { AnalyticsService } from '../../../../../services/analytics/analytics.service';
import { SearchQuery } from '../../../../../core/interfaces/search.interface';
import { SharedService } from '../../../../../services/shared/shared.service';

@Component({
  selector: 'ag-clcd-study-programs',
  templateUrl: './study-programs.component.html',
  styleUrls: ['./study-programs.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class StudyProgramsComponent implements OnInit {
  @Input() age: Age;
  @Input() studyProgram: StudyProgram;

  recommendedAge: string;
  recommendedGrade: string;

  constructor(
    private _searchService: SearchService,
    private _analyticsService: AnalyticsService,
    private _sharedService: SharedService,
  ) {}

  ngOnInit(): void {
    if (this.age) {
      this.recommendedAge =
        this.age.min === this.age.max ? `${this.age.min}` : `${this.age.min}-${this.age.max}`;
    }
  }

  search(searchQuery: SearchQuery, eventName: string) {
    this._analyticsService.logEvent(`CLCD ${eventName}`);
    this._searchService.search(searchQuery);
  }
}
